// import { Api } from '@/service';

//restful api
import { system as log } from '@/service/api/log'

export default {
  data : () => {
    return {
      model : {},
    }
  },
  methods: {
    list() { this.$router.push({ name: 'log_system'}); },
    async get( id = this.$route.params) {
      console.log('log.system.detail.vue', 'load item', id);
      try {
        // let rs = await Api.Manager_Call('log.system', 'detail', { id : Number(id.id) })
        let rs = await log.detailSys({ id : Number(id.id) })
        this.model = rs.body;
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText), this.list() }
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created() { console.log('log.system.detail.vue', 'created'); },
  destroyed() { console.log('log.system.detail.vue', 'destroyed'); },
  mounted() {
    console.log('log.system.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}